import { render } from "./SurveyEditorStepFour.vue?vue&type=template&id=c790ecf8"
import script from "./SurveyEditorStepFour.vue?vue&type=script&lang=js"
export * from "./SurveyEditorStepFour.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__